import { SkillsMatrixOptions, getSkillsMatrix, SkillsMatrix } from '~/monolith-api';
import { useRegisteredQuery } from '~/queries';

const KEY = 'skills-matrix';

export function useSkillsMatrix(options: SkillsMatrixOptions) {
   return useRegisteredQuery([KEY, options], async (): Promise<SkillsMatrix> => {
      return await getSkillsMatrix(options);
   });
}
